<template>
  <div>
    <div class="header">
      <h1>Delivered</h1>
      <form @submit.prevent>
        <div class="input-group">
          <span class="input-group-addon">
            <span class="icon icon-search"></span>
          </span>
          <input type="search" name="query" v-model.trim="query" class="form-control" placeholder="Search" />
        </div>
      </form>
    </div>
    <div class="datatable">
      <table class="table bb-datatable">
        <thead>
          <tr>
            <td>Email Address</td>
            <td class="text-right">Delivered At</td>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading">
            <td class="text-center" colspan="2"><i class="fa fa-spin fa-spinner fa-fw"></i></td>
          </tr>
          <tr v-for="result in filteredResults" v-if="!loading">
            <td>
              <router-link :to="'/contacts/' + result.contact_uuid">{{ result.email }}</router-link>
            </td>
            <td class="text-right">{{ result.latest_timestamp | humanDateTime }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  import * as api from '@/api';

  export default {
    props: ['typeUuid'],
    data() {
      return {
        loading: true,
        results: [],
        query: '',
      };
    },
    created() {
      api.emailPerformanceContacts(this.typeUuid, 'delivered').then((response) => {
        this.results = response.contacts;
        this.loading = false;
      }).catch((err) => {
        this.$toasted.error(err.message);
      });
    },
    computed: {
      filteredResults() {
        if (this.query.length) {
          return this.results.filter(r =>
            r.email.toLowerCase().indexOf(this.query.toLowerCase()) > -1,
          );
        }

        return this.results;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .header {
    margin-top: 1.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  h1 {
    text-transform: capitalize;
    font-size: 1.25rem;
    font-weight: normal;
    color: #212B36;
    line-height: 1.5rem;
  }
</style>

